import React,{ useState, useEffect } from 'react';
import { View, TextInput, StyleSheet, Image, TouchableOpacity } from 'react-native';
import { THEME_COLORS, images } from '../themes';
import { Text } from './index';

interface IInputWithActionInterface{
    value?:string;
    onChange:(obj:any)=>void;
    label:string;
    showLabel:boolean;
}

export const InputWithAction=(props:IInputWithActionInterface)=>{
    
    const { value, onChange, showLabel, label } = props;

    const [inputValue,setInputValue] = useState(value);
    const [isEditable,setIsEditable] = useState(false);

    useEffect(()=>{
        setInputValue(value);
    },[value]);

   const onTickPress=()=>{
    onChange(inputValue);
    setIsEditable(false);
   }
    
    return (
        <View style={styles.container}>
            {
                showLabel && <Text>{label ?? ""} : </Text>
            }
            <View style={styles.childContainer}>
                <TextInput
                    editable={isEditable}
                    onFocus={()=>setIsEditable(true)}
                    value={inputValue} 
                    style={{maxWidth:40}}
                    onChangeText={t => setInputValue(t)}
                />
                {isEditable && <View style={{flexDirection:"row"}}>
                    <TouchableOpacity style={styles.imageContainer} onPress={onTickPress}>
                        <Image source={images.tickIcon} style={styles.touchableImage}/>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.imageContainer} onPress={()=>setIsEditable(false)}>
                        <Image source={images.crossIcon} style={styles.touchableImage}/>
                    </TouchableOpacity>
                </View>}
            </View>
        </View>
    )
}


const styles = StyleSheet.create({
    container:{
        flexDirection:"row",
        alignItems:"center",
        marginHorizontal:10,
        paddingHorizontal:10,
        paddingVertical:5,
        height:40,
        borderLeftColor:THEME_COLORS.grey3,
        borderLeftWidth:1,
    },
    childContainer:{
        backgroundColor:THEME_COLORS.grey3,
        marginHorizontal:5,
        alignItems:"center",
        flexDirection:"row",
        padding:5,
        borderRadius:5,
        height:"100%"
    },
    imageContainer:{
        paddingHorizontal:10
    },
    touchableImage:{
        width:14,
        height:14
    }
})